module.exports = __webpack_public_path__ + "img/gamification-icon.7004ef4e.svg";